module.exports = __webpack_public_path__ + "static/media/website.e1492be.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/website.mp4
// module id = ril6
// module chunks = 15